package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.SystemConfigRepository
import com.clany.backoffice.model.SystemConfigResponse
import dev.zacsweers.metro.Inject

class GetSystemConfigsUseCase @Inject constructor(
    private val repository: SystemConfigRepository
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
        query: String? = null
    ): Result<List<SystemConfigResponse>> = repository.getSystemConfigs(page, pageSize, query)
}
